module.exports = function getResource (label) {
    const resources = {
        addPromoCode: 'Add promo code',
        enterPromoRewards: 'Enter Promo & Rewards'
    };
    return resources[label];
};
